import React from "react";
// import MDBox from "components/MDBox";
import PlanningTable from "./components/PlanningTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AssignReplacementDialog from "./components/AssignReplacementDialog";
function Planning() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PlanningTable />
      <AssignReplacementDialog/>
    </DashboardLayout>
  );
}

export default Planning;
